import { render, staticRenderFns } from "./RouteBuilder.vue?vue&type=template&id=96dd0ace&"
import script from "./RouteBuilder.vue?vue&type=script&lang=js&"
export * from "./RouteBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports